import type { QuoteItem_ } from 'src/api/db/apiQuoteItem'
import { useLocalization } from 'src/shared/hooks/useLocalization'
import { itemHasLogoVisual } from '../utils'
import { ProposalItemVisual } from './ProposalItemVisual'

const MAX_MOCKUPS = 6

/** "Your logo, on the real thing" — mockups for the options currently chosen. */
export const ProposalMockups = ({ items }: { items: QuoteItem_[] }) => {
  const { t } = useLocalization()
  const withMockups = items.filter(itemHasLogoVisual)
  if (withMockups.length === 0) return null

  return (
    <section className="flex flex-col gap-3.5 rounded-[20px] border border-[var(--raised-border)] bg-proposal-surface shadow-soft p-5 sm:p-6">
      <h2 className="m-0 text-base font-semibold tracking-[-0.01em] text-proposal-ink">
        {t('Your logo, on the real thing', 'Er logga, på riktigt')}
      </h2>
      <p className="m-0 text-[14.5px] leading-normal text-proposal-ink-soft">
        {t(
          'Generated from your brand files. Approve the proposal and we send factory proofs before anything is printed.',
          'Skapade från era varumärkesfiler. Godkänn förslaget så skickar vi fabrikskorrektur innan något trycks.'
        )}
      </p>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
        {withMockups.slice(0, MAX_MOCKUPS).map((item) => (
          <ProposalItemVisual
            key={item.id}
            item={item}
            alt={item.product?.item_name || t('Mockup', 'Mockup')}
            className="aspect-square w-full rounded-xl bg-proposal-placeholder"
            imgClassName="object-contain"
          />
        ))}
      </div>
    </section>
  )
}
